import { FC, useCallback, useMemo, useState } from "react"
import { X } from "lucide-react"
import OrgAutocomplete from "../../org-autocomplete"
import {
  useFetchOrgListQuery,
  useFetchBillingConfigQuery
} from "../../../../redux/queries"
import BillingForm from "./billing-form"

const ConfigBilling: FC = () => {
  const [selectedOrgId, setSelectedOrgId] = useState<string>("")

  const { data: orgs } = useFetchOrgListQuery({ limit: 999 })

  const { data: billingConfigs, isFetching } = useFetchBillingConfigQuery(
    { org_id: selectedOrgId },
    { skip: !selectedOrgId }
  )

  const config = useMemo(
    () => (billingConfigs?.length ? billingConfigs[0] : null),
    [billingConfigs]
  )

  const selectedOrgName = useMemo(
    () => orgs?.find(o => o.id === selectedOrgId)?.name ?? "",
    [orgs, selectedOrgId]
  )

  const handleClear = useCallback(() => {
    setSelectedOrgId("")
  }, [])

  return (
    <div>
      <div className="flex items-end gap-3 mb-6">
        <OrgAutocomplete
          selected={selectedOrgId}
          orgs={orgs ?? []}
          onChange={setSelectedOrgId}
        />
        {selectedOrgId && (
          <button
            type="button"
            onClick={handleClear}
            className="mb-px p-2 text-gray-400 hover:text-gray-600 transition-colors"
            title="Clear selection"
          >
            <X size={18} />
          </button>
        )}
      </div>

      {selectedOrgId && isFetching && (
        <div className="text-sm text-gray-500">Loading billing config...</div>
      )}

      {selectedOrgId && !isFetching && (
        <div>
          <div className="mb-4">
            <h2 className="text-base font-semibold text-gray-900">
              {selectedOrgName}
            </h2>
            <p className="text-xs text-gray-500">
              {config
                ? "Edit existing billing configuration"
                : "No billing config found — create one below"}
            </p>
          </div>
          <BillingForm
            orgId={selectedOrgId}
            config={config}
            onDeleted={handleClear}
          />
        </div>
      )}
    </div>
  )
}

export default ConfigBilling
